import { isValid, parse } from "date-fns";

const HORAS_BLOQUEIO_DEVOLUCAO = 3;

type BilheteResumo = {
  embarque?: string | null;
  devolucao_bloqueada?: boolean | null;
  devolucao_presencial?: boolean | null;
};

type ViagemResumo = {
  detalhes?: {
    saida?: string | null;
    devolucao_bloqueada?: boolean | null;
    devolucao_presencial?: boolean | null;
  };
  bilhetes?: BilheteResumo[];
};

type ServicoResumo = {
  viagens?: ViagemResumo[];
};

type BilhetesPedidoResumo = Record<string, ServicoResumo[]>;

function parseDataHoraFlexivel(value?: string | null): Date | null {
  const raw = (value ?? "").trim();
  if (raw === "") {
    return null;
  }

  const formatos = [
    "dd/MM/yyyy HH:mm:ss",
    "dd/MM/yyyy HH:mm",
    "yyyy-MM-dd HH:mm:ss",
    "yyyy-MM-dd HH:mm",
  ];

  for (const formato of formatos) {
    const parsed = parse(raw, formato, new Date());
    if (isValid(parsed)) {
      return parsed;
    }
  }

  const candidatos = [raw, raw.replace(" ", "T")];
  for (const candidato of candidatos) {
    const data = new Date(candidato);
    if (isValid(data)) {
      return data;
    }
  }

  return null;
}

function isMesmoDia(dataA: Date, dataB: Date): boolean {
  return dataA.getFullYear() === dataB.getFullYear()
    && dataA.getMonth() === dataB.getMonth()
    && dataA.getDate() === dataB.getDate();
}

function estaDentroDaJanelaDeBloqueioDevolucao(embarque: Date): boolean {
  const agora = new Date();
  if (!isMesmoDia(agora, embarque)) {
    return false;
  }

  const limite = new Date(embarque.getTime() - (HORAS_BLOQUEIO_DEVOLUCAO * 60 * 60 * 1000));

  return agora >= limite;
}

export function deveBloquearDevolucaoPorEmbarque(
  embarqueRaw?: string | null,
  bloqueioExplicito?: boolean | null
): boolean {
  if (typeof bloqueioExplicito === "boolean") {
    return bloqueioExplicito;
  }

  const embarque = parseDataHoraFlexivel(embarqueRaw);
  if (!embarque) {
    return false;
  }

  return estaDentroDaJanelaDeBloqueioDevolucao(embarque);
}

export function deveBloquearDevolucaoNoPedido(bilhetes: BilhetesPedidoResumo): boolean {
  const contextos = Object.values(bilhetes ?? {});

  for (const servicos of contextos) {
    if (!Array.isArray(servicos)) {
      continue;
    }

    for (const servico of servicos) {
      const viagens = Array.isArray(servico.viagens) ? servico.viagens : [];

      for (const viagem of viagens) {
        if (
          deveBloquearDevolucaoPorEmbarque(
            viagem?.detalhes?.saida,
            viagem?.detalhes?.devolucao_bloqueada
          )
        ) {
          return true;
        }

        for (const bilhete of viagem?.bilhetes ?? []) {
          if (
            deveBloquearDevolucaoPorEmbarque(
              bilhete?.embarque,
              bilhete?.devolucao_bloqueada
            )
          ) {
            return true;
          }
        }
      }
    }
  }

  return false;
}

export function deveBloquearDevolucaoPresencialNoPedido(bilhetes: BilhetesPedidoResumo): boolean {
  const contextos = Object.values(bilhetes ?? {});

  for (const servicos of contextos) {
    if (!Array.isArray(servicos)) {
      continue;
    }

    for (const servico of servicos) {
      const viagens = Array.isArray(servico.viagens) ? servico.viagens : [];

      for (const viagem of viagens) {
        if (viagem?.detalhes?.devolucao_presencial) {
          return true;
        }

        for (const bilhete of viagem?.bilhetes ?? []) {
          if (bilhete?.devolucao_presencial) {
            return true;
          }
        }
      }
    }
  }

  return false;
}
